/*
 Calcula el digito verificador de una patente antigua o nueva, de autos , motos y carros de arrastre
Autor: Benjamín León
Fecha: 2025-02-27
 */
const _variables = {
  MAX_LENGTH: 6,
  validLetters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  motoNewFormat: {
    name: 'motoNewFormat',
    type: 'LLL.NNN',
  },
  motoOldFormat: {
    name: 'motoOldFormat',
    type: 'LL.NNNN',
  },
  autoNewFormat: {
    name: 'autoNewFormat',
    type: 'LLLL.NN',
  },
  autoOldFormat: {
    name: 'autoOldFormat',
    type: 'LL.NNNN',
  },
  carroArrastreFormat: {
    name: 'carroArrastreFormat',
    type: 'LLL.NNN',
  },
}
const _letterDvDb: Record<string, string> = {
  B: '1',
  C: '2',
  D: '3',
  F: '4',
  G: '5',
  H: '6',
  J: '7',
  K: '8',
  L: '9',
  P: '0',
  R: '2',
  S: '3',
  T: '4',
  V: '5',
  W: '6',
  X: '7',
  Y: '8',
  Z: '9',
  AA: '001',
  EA: '004',
  HA: '007',
  EB: '010',
  HB: '013',
  EC: '016',
  HC: '019',
  FD: '022',
  AE: '025',
  EE: '028',
  HE: '031',
  CF: '034',
  GF: '037',
  BG: '040',
  FG: '043',
  BH: '046',
  FH: '049',
  AJ: '052',
  EJ: '055',
  HJ: '058',
  EK: '061',
  HK: '064',
  CL: '067',
  GL: '070',
  BN: '073',
  FN: '076',
  AP: '079',
  EP: '082',
  HP: '085',
  BA: '002',
  FA: '005',
  AB: '008',
  FB: '011',
  AC: '014',
  FC: '017',
  BD: '020',
  GD: '023',
  BE: '026',
  FE: '029',
  AF: '032',
  EF: '035',
  HF: '038',
  CG: '041',
  HG: '044',
  CH: '047',
  GH: '050',
  BJ: '053',
  FJ: '056',
  BK: '059',
  FK: '062',
  AL: '065',
  EL: '068',
  HL: '071',
  CN: '074',
  GN: '077',
  BP: '080',
  FP: '083',
  AR: '086',
  CA: '003',
  GA: '006',
  CB: '009',
  GB: '012',
  BC: '015',
  GC: '018',
  ED: '021',
  HD: '024',
  CE: '027',
  GE: '030',
  BF: '033',
  FF: '036',
  AG: '039',
  EG: '042',
  AH: '045',
  EH: '048',
  HH: '051',
  CJ: '054',
  GJ: '057',
  CK: '060',
  GK: '063',
  BL: '066',
  FL: '069',
  AN: '072',
  EN: '075',
  HN: '078',
  CP: '081',
  GP: '084',
  BR: '087',
  CR: '088',
  GR: '091',
  BS: '094',
  FS: '097',
  AT: '100',
  ET: '103',
  HT: '106',
  CU: '109',
  GU: '112',
  BV: '115',
  FV: '118',
  AX: '121',
  EX: '124',
  HX: '127',
  EY: '130',
  HY: '133',
  CZ: '136',
  GZ: '139',
  DD: '142',
  DG: '145',
  DJ: '148',
  DN: '151',
  DS: '154',
  DV: '157',
  DZ: '160',
  KC: '163',
  KF: '166',
  KJ: '169',
  KN: '172',
  KS: '175',
  ER: '089',
  HR: '092',
  CS: '095',
  GS: '098',
  BT: '101',
  FT: '104',
  AU: '107',
  EU: '110',
  HU: '113',
  CV: '116',
  GV: '119',
  BX: '122',
  FX: '125',
  BY: '128',
  FY: '131',
  AZ: '134',
  EZ: '137',
  DA: '140',
  DE: '143',
  DH: '146',
  DK: '149',
  DP: '152',
  DT: '155',
  DX: '158',
  KA: '161',
  KD: '164',
  KG: '167',
  KK: '170',
  KP: '173',
  KT: '176',
  FR: '090',
  AS: '093',
  ES: '096',
  HS: '099',
  CT: '102',
  GT: '105',
  BU: '108',
  FU: '111',
  AV: '114',
  EV: '117',
  HV: '120',
  CX: '123',
  GX: '126',
  CY: '129',
  GY: '132',
  BZ: '135',
  FZ: '138',
  DB: '141',
  DF: '144',
  DI: '147',
  DL: '150',
  DR: '153',
  DU: '156',
  DY: '159',
  KB: '162',
  KE: '165',
  KH: '168',
  KL: '171',
  KR: '174',
  KU: '177',
  KV: '178',
  KZ: '181',
  LC: '184',
  LF: '187',
  LJ: '190',
  LN: '193',
  LS: '196',
  LV: '199',
  LZ: '202',
  NC: '205',
  NF: '208',
  NJ: '211',
  NN: '214',
  NS: '217',
  NV: '220',
  PA: '223',
  PD: '226',
  PG: '229',
  PK: '232',
  PP: '235',
  PU: '238',
  PY: '241',
  RA: '244',
  RD: '247',
  RG: '250',
  RK: '253',
  RP: '256',
  RT: '259',
  RX: '262',
  HZ: '265',
  KX: '179',
  LA: '182',
  LD: '185',
  LG: '188',
  LK: '191',
  LP: '194',
  LT: '197',
  LX: '200',
  NA: '203',
  ND: '206',
  NG: '209',
  NK: '212',
  NP: '215',
  NT: '218',
  NY: '221',
  PB: '224',
  PE: '227',
  PH: '230',
  PL: '233',
  PS: '236',
  PV: '239',
  PZ: '242',
  RB: '245',
  RE: '248',
  RH: '251',
  RL: '254',
  RR: '257',
  RU: '260',
  RY: '263',
  SA: '266',
  KY: '180',
  LB: '183',
  LE: '186',
  LH: '189',
  LL: '192',
  LR: '195',
  LU: '198',
  LY: '201',
  NB: '204',
  NE: '207',
  NH: '210',
  NL: '213',
  NR: '216',
  NU: '219',
  NZ: '222',
  PC: '225',
  PF: '228',
  PJ: '231',
  PN: '234',
  PT: '237',
  PX: '240',
  NX: '243',
  RC: '246',
  RF: '249',
  RJ: '252',
  RN: '255',
  RS: '258',
  RV: '261',
  RZ: '264',
  SB: '267',
  SC: '268',
  SF: '271',
  SJ: '274',
  SN: '277',
  SS: '280',
  SV: '283',
  SZ: '286',
  TC: '289',
  TF: '292',
  TJ: '295',
  TN: '298',
  TS: '301',
  TV: '304',
  TZ: '307',
  UC: '310',
  UF: '313',
  UJ: '316',
  UN: '319',
  US: '322',
  UV: '325',
  UZ: '328',
  VC: '331',
  VF: '334',
  VJ: '337',
  VN: '340',
  VS: '343',
  VV: '346',
  VZ: '349',
  XC: '352',
  XF: '355',
  SD: '269',
  SG: '272',
  SK: '275',
  SP: '278',
  ST: '281',
  SX: '284',
  TA: '287',
  TD: '290',
  TG: '293',
  TK: '296',
  TP: '299',
  TT: '302',
  TX: '305',
  UA: '308',
  UD: '311',
  UG: '314',
  UK: '317',
  UP: '320',
  UT: '323',
  UX: '326',
  VA: '329',
  VD: '332',
  VG: '335',
  VK: '338',
  VP: '341',
  VT: '344',
  VX: '347',
  XA: '350',
  XD: '353',
  XG: '356',
  SE: '270',
  SH: '273',
  SL: '276',
  SR: '279',
  SU: '282',
  SY: '285',
  TB: '288',
  TE: '291',
  TH: '294',
  TL: '297',
  TR: '300',
  TU: '303',
  TY: '306',
  UB: '309',
  UE: '312',
  UH: '315',
  UL: '318',
  UR: '321',
  UU: '324',
  UY: '327',
  VB: '330',
  VE: '333',
  VH: '336',
  VL: '339',
  VR: '342',
  VU: '345',
  VY: '348',
  XB: '351',
  XE: '354',
  XH: '357',
  XJ: '358',
  XM: '361',
  XQ: '364',
  XT: '367',
  XX: '370',
  YA: '373',
  JB: '376',
  JE: '379',
  YE: '382',
  YH: '385',
  YL: '388',
  YR: '391',
  YU: '394',
  YY: '397',
  ZB: '400',
  ZE: '403',
  ZH: '406',
  ZK: '409',
  JG: '412',
  ZP: '415',
  ZT: '418',
  ZX: '421',
  WA: '430',
  WD: '433',
  WG: '436',
  WK: '439',
  WP: '442',
  WT: '445',
  JK: '448',
  XK: '359',
  XN: '362',
  XR: '365',
  XU: '368',
  XY: '371',
  YB: '374',
  JC: '377',
  YC: '380',
  YF: '383',
  YJ: '386',
  YN: '389',
  YS: '392',
  YV: '395',
  YZ: '398',
  ZC: '401',
  ZF: '404',
  ZI: '407',
  ZL: '410',
  JH: '413',
  ZR: '416',
  ZU: '419',
  ZY: '422',
  WB: '431',
  WE: '434',
  WH: '437',
  WL: '440',
  WR: '443',
  WU: '446',
  WV: '449',
  XL: '360',
  XP: '363',
  XS: '366',
  XV: '369',
  XZ: '372',
  JA: '375',
  JD: '378',
  YD: '381',
  YG: '384',
  YK: '387',
  YP: '390',
  YT: '393',
  YX: '396',
  ZA: '399',
  ZD: '402',
  ZG: '405',
  ZJ: '408',
  JF: '411',
  ZN: '414',
  ZS: '417',
  ZV: '420',
  ZZ: '423',
  WC: '432',
  WF: '435',
  WJ: '438',
  WN: '441',
  WS: '444',
  JJ: '447',
  WW: '450',
  WX: '451',
  ZW: '454',
  UW: '457',
  RW: '460',
  LW: '463',
  MY: '466',
  MU: '469',
  JL: '424',
  JP: '427',
  JT: '472',
  JW: '475',
  JZ: '478',
  MC: '481',
  MF: '484',
  MJ: '487',
  MN: '490',
  IA: '493',
  ID: '496',
  IG: '499',
  IK: '502',
  IO: '505',
  IS: '508',
  IV: '511',
  IY: '514',
  QB: '517',
  QE: '520',
  QH: '523',
  QL: '526',
  QP: '529',
  QT: '532',
  WY: '452',
  YW: '455',
  TW: '458',
  PW: '461',
  KW: '464',
  MX: '467',
  MT: '470',
  JN: '425',
  JR: '428',
  JU: '473',
  JX: '476',
  MA: '479',
  MD: '482',
  MG: '485',
  MK: '488',
  MP: '491',
  IB: '494',
  IE: '497',
  IH: '500',
  IL: '503',
  IP: '506',
  IT: '509',
  IW: '512',
  IZ: '515',
  QC: '518',
  QF: '521',
  QJ: '524',
  QN: '527',
  QR: '530',
  QU: '533',
  WZ: '453',
  XW: '456',
  SW: '459',
  NW: '462',
  MZ: '465',
  MV: '468',
  MS: '471',
  JO: '426',
  JS: '429',
  JV: '474',
  JY: '477',
  MB: '480',
  ME: '483',
  MH: '486',
  ML: '489',
  MR: '492',
  IC: '495',
  IF: '498',
  IJ: '501',
  IN: '504',
  IR: '507',
  IU: '510',
  IX: '513',
  QA: '516',
  QD: '519',
  QG: '522',
  QK: '525',
  QO: '528',
  QS: '531',
  QV: '534',
  QW: '535',
  QZ: '538',
  OC: '541',
  OF: '544',
  OJ: '547',
  ON: '550',
  OR: '553',
  OU: '556',
  OX: '559',
  AD: '562',
  AM: '565',
  BB: '568',
  BO: '571',
  CD: '574',
  CO: '577',
  DM: '580',
  QX: '536',
  OA: '539',
  OD: '542',
  OG: '545',
  OK: '548',
  OO: '551',
  OS: '554',
  OV: '557',
  OY: '560',
  AI: '563',
  AW: '566',
  BI: '569',
  BW: '572',
  CI: '575',
  CW: '578',
  DO: '581',
  QY: '537',
  OB: '540',
  OE: '543',
  OH: '546',
  OL: '549',
  OP: '552',
  OT: '555',
  OW: '558',
  OZ: '561',
  AK: '564',
  AY: '567',
  BM: '570',
  CC: '573',
  CM: '576',
  DC: '579',
  DW: '582',
}

interface PpuFormat {
  name: string
  type: string
}

const verifyPpuType = (ppu: string): PpuFormat => {
  if (ppu.length !== _variables.MAX_LENGTH) {
    throw new Error('La patente ingresada es de largo inválido')
  }

  if (isMotoNew(ppu)) return _variables.motoNewFormat

  if (isMotoOld(ppu)) return _variables.motoOldFormat

  if (isAutoMovilNew(ppu)) return _variables.autoNewFormat

  if (isAutoMovilOld(ppu)) return _variables.autoOldFormat

  if (isCarroArrastre(ppu)) {
    throw new Error('CARRO DE ARRASTRE no es un formato válido.')
  }
  throw new Error(`Patente [${ppu}] no corresponde a ningun formato válido`)
}

const isAutoMovilNew = (ppu: string): boolean => {
  //  return /^[b-df-hj-lp-rt-vz]{2}[-. ]?[b-df-hj-lp-rt-vz]{2}[-. ]?\d{2}$/i.test(ppu);
  if (hasVowel(ppu)) return false

  return /^[a-z]{4}\d{2}$/i.test(ppu)
}

const isAutoMovilOld = (ppu: string): boolean => {
  return /^[a-z]{2}\d{4}$/i.test(ppu)
}

const isMotoOld = (ppu: string): boolean => {
  return /^[a-z]{2}0\d{3}$|^[a-z]{2}\d{3}$/i.test(ppu)
}

const isMotoNew = (ppu: string): boolean => {
  if (hasVowel(ppu)) return false

  return /^[a-z]{3}\d{2}$|^[a-z]{3}0\d{2}$/i.test(ppu)
}

const isCarroArrastre = (ppu: string): boolean => {
  return /^[a-z]{3}[1-9]\d{2}$/i.test(ppu)
}

const transformInPreNumber = (ppu: string, format: PpuFormat): number[] => {
  const type = format.type

  if (type === 'LLL.NNN' || type === 'LLLL.NN') {
    return Array.from(ppu).map((char) => {
      return isNaN(parseInt(char)) ? parseInt(_letterDvDb[char.toUpperCase()]) : parseInt(char)
    })
  }

  if (type === 'LL.NNNN') {
    const ppuLetters = ppu.substring(0, 2)
    const ppuNumbersASstring = ppu.substring(2, 6)
    const ppuLettersTransformed = lettersToNumbers(ppuLetters)

    return Array.from(ppuLettersTransformed + ppuNumbersASstring).map(Number)
  }

  return []
}

const lettersToNumbers = (ppuLetters: string): string => {
  const transformedPpuLetters = _letterDvDb[ppuLetters]

  if (typeof transformedPpuLetters === 'string') {
    return transformedPpuLetters
  }
  throw new Error('Letras de patente de Auto Antiguo inválidas')
}

const calculateDv = (numbers: number[], format: PpuFormat): string => {
  if (format.type === 'LL.NNNN') {
    const S =
      numbers[6] * 2 +
      numbers[5] * 3 +
      numbers[4] * 4 +
      numbers[3] * 5 +
      numbers[2] * 6 +
      numbers[1] * 7 +
      numbers[0] * 2
    const Ri = S % 11
    const Rf = 11 - Ri
    let result

    if (Rf === 11) {
      result = '0'
    } else if (Rf === 10) {
      result = 'K'
    } else {
      result = Rf.toString()
    }

    return result
  }

  if (format.type === 'LLL.NNN' || format.type === 'LLLL.NN') {
    const SP = numbers[5] * 2 + numbers[4] * 3 + numbers[3] * 4 + numbers[2] * 5 + numbers[1] * 6 + numbers[0] * 7
    const R = SP % 11
    let result

    if (R === 0) {
      result = '0'
    } else {
      const value = 11 - R

      if (value === 10) {
        result = 'K'
      } else {
        result = value.toString()
      }
    }

    return result
  }

  return ''
}
export interface CalcPlateDvResult {
  ok: boolean
  plate: string
  msg: string
}
const calcPlateDv = (plate: string): CalcPlateDvResult => {
  try {
    const plate_format = plate.toUpperCase().trim()
    const type = verifyPpuType(plate_format)
    const numbers = transformInPreNumber(plate_format, type)
    // Si hay algún numero NaN, quiere decir que la patente
    // tiene alguna ñetra no válida
    const malo = numbers.find((n) => isNaN(n))

    if (typeof malo !== 'undefined') {
      const msg = `Letra inválida en patente: ${plate_format}`
      throw new Error(msg)
    }
    const dv = calculateDv(numbers, type)
    const res = {
      ok: true,
      plate: `${plate_format}-${dv}`,
      msg: '',
    }

    return res
  } catch (err) {
    const msg = esError(err) ? err.message : 'Error en calcPlateDv '
    const res = {
      ok: false,
      plate: plate,
      msg: msg,
    }

    return res
  }
}
const hasVowel = (str: string): boolean => {
  const vowels = ['a', 'e', 'i', 'o', 'u', 'A', 'E', 'I', 'O', 'U']

  for (const char of str) {
    if (vowels.includes(char)) {
      return true
    }
  }

  return false
}
const esError = (obj: unknown): obj is Error => obj instanceof Error
export default calcPlateDv
